import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getNotificationsUserState, selectAuth } from 'features/auth/authSlice';
import { getNfts, selectNft } from 'features/auth/nftSlice';

import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import {
  MainPageProvider,
  NotificationProvider,
  UserProvider,
} from './context';
import AppRouter from './routes/router';
import { getOtrs, selectOtr } from 'features/auth/otrSlice';

function App() {
  const authState = useAppSelector(selectAuth);
  const nftState = useAppSelector(selectNft);
  const otrState = useAppSelector(selectOtr);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!nftState.nfts) dispatch(getNfts());
    if (!otrState.otrs) dispatch(getOtrs());
    if (authState.id) {
      dispatch(getNotificationsUserState(authState.id));
    }
    //eslint-disable-next-line
  }, [authState.id, dispatch]);

  return (
    <UserProvider>
      <MainPageProvider>
        <NotificationProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </NotificationProvider>
      </MainPageProvider>
    </UserProvider>
  );
}

export default App;
